import { render, staticRenderFns } from "./TAVSecurityInPress.vue?vue&type=template&id=2e4c890d&scoped=true&"
import script from "./TAVSecurityInPress.vue?vue&type=script&lang=js&"
export * from "./TAVSecurityInPress.vue?vue&type=script&lang=js&"
import style0 from "./TAVSecurityInPress.vue?vue&type=style&index=0&id=2e4c890d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4c890d",
  null
  
)

export default component.exports